import { useState, useEffect, useRef, memo } from "react";
import axios from "axios";
import { MdOutlineFileUpload } from "react-icons/md";
import { toast } from "react-hot-toast";
import { Navigate, useNavigate } from "react-router-dom";
import backarrow from "../assets/icon/arrow-right.svg";
import { motion } from "framer-motion";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import {
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
} from "react-icons/fa";

// پس زمینه متحرک
const icons = [
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
];

const staticBackgroundIcons = (() => {
  const rows = 5,
      cols = 11,
      arr = [];
  for (let i = 0; i < rows; i++)
    for (let j = 0; j < cols; j++) {
      const Icon = icons[Math.floor(Math.random() * icons.length)];
      arr.push({
        Icon,
        size: 18 + Math.random() * 20,
        top: (i / rows) * 100 + Math.random() * 5,
        left: (j / cols) * 100 + Math.random() * 5,
        duration: 12 + Math.random() * 10,
        opacity: 0.15 + Math.random() * 0.25,
        xOffset: Math.random() * 10 - 5,
        yOffset: Math.random() * 10 - 5,
      });
    }
  return arr;
})();

const AnimatedBackground = memo(() => (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {staticBackgroundIcons.map((item, i) => (
          <motion.div
              key={i}
              className="absolute text-white/50"
              style={{
                top: `${item.top}%`,
                left: `${item.left}%`,
                opacity: item.opacity,
              }}
              initial={{ scale: 0.5 }}
              animate={{
                x: [0, item.xOffset, 0],
                y: [0, item.yOffset, 0],
                scale: [0.5, 1, 0.5],
              }}
              transition={{
                duration: item.duration,
                repeat: Infinity,
                ease: "easeInOut",
              }}
          >
            <item.Icon size={item.size} />
          </motion.div>
      ))}
    </div>
));

const AddCourse = () => {
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_URL;

  const [courseName, setCourseName] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState("");
  const [dateValue, setDateValue] = useState(null);

  const [teacherName, setTeacherName] = useState("");
  const [teacherCode, setTeacherCode] = useState("");
  const [teachers, setTeachers] = useState([]);
  const [showTeacherList, setShowTeacherList] = useState(false);
  const [teacherLoading, setTeacherLoading] = useState(false);

  const [studentName, setStudentName] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedStudentNames, setSelectedStudentNames] = useState({}); // {National_Code: "نام کامل"}
  const [students, setStudents] = useState([]);
  const [showStudentList, setShowStudentList] = useState(false);
  const [studentLoading, setStudentLoading] = useState(false);

  const [price, setPrice] = useState("");
  const [hasDiscount, setHasDiscount] = useState(false);
  const [discount, setDiscount] = useState("");
  const [finalPrice, setFinalPrice] = useState(0);

  const [uploadImage, setUploadImage] = useState("");
  const [showUploadIcon, setShowUploadIcon] = useState(true);
  const [imageId, setImageId] = useState("");

  const teacherRef = useRef(null);
  const studentRef = useRef(null);

  useEffect(() => {
    const p = Number(price) || 0;
    const d = Number(discount) || 0;
    const discounted = p - (p * d) / 100;
    setFinalPrice(Math.round(discounted));
  }, [price, discount]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (teacherRef.current && !teacherRef.current.contains(e.target))
        setShowTeacherList(false);
      if (studentRef.current && !studentRef.current.contains(e.target))
        setShowStudentList(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const searchTeachers = async (query) => {
    if (!query.trim()) {
      setTeachers([]);
      return;
    }
    setTeacherLoading(true);
    try {
      const res = await axios.get(
          `${API_BASE}/api/teacher/Get-All-Teacher?search=${query}`,
          {
            headers: { Authorization: localStorage.getItem("token") },
          }
      );
      setTeachers(res.data.data.teachers || []);
    } catch {
      toast.error("خطا در دریافت اساتید");
      setTeachers([]);
    } finally {
      setTeacherLoading(false);
    }
  };

  const searchStudents = async (query) => {
    if (!query.trim()) {
      setStudents([]);
      return;
    }
    setStudentLoading(true);
    try {
      const res = await axios.get(
          `${API_BASE}/api/student/Get-All-Student?search=${query}`,
          {
            headers: { Authorization: localStorage.getItem("token") },
          }
      );
      setStudents(res.data.data.students || []);
    } catch {
      toast.error("خطا در دریافت دانشجویان");
      setStudents([]);
    } finally {
      setStudentLoading(false);
    }
  };

  // تابع فشرده‌سازی تصویر
  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');

          let maxDimension = 600;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxDimension) {
              height = (height * maxDimension) / width;
              width = maxDimension;
            }
          } else {
            if (height > maxDimension) {
              width = (width * maxDimension) / height;
              height = maxDimension;
            }
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
              (blob) => {
                if (!blob) {
                  reject(new Error('خطا در فشرده‌سازی'));
                  return;
                }

                const compressedFile = new File([blob], file.name.replace(/\.[^/.]+$/, '.jpg'), {
                  type: 'image/jpeg',
                  lastModified: Date.now(),
                });

                resolve(compressedFile);
              },
              'image/jpeg',
              0.6
          );
        };

        img.onerror = () => reject(new Error('خطا در بارگذاری تصویر'));
      };

      reader.onerror = () => reject(new Error('خطا در خواندن فایل'));
    });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      toast.error('لطفاً یک فایل تصویری انتخاب کنید');
      return;
    }

    setShowUploadIcon(false);

    try {
      const compressedFile = await compressImage(file);

      const formData = new FormData();
      formData.append("file", compressedFile);

      const res = await axios.post(
          `${API_BASE}/api/files/admin/upload-file`,
          formData,
          {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          }
      );

      toast.success("تصویر دوره آپلود شد");
      setImageId(res.data.data.fileId);
      setUploadImage(URL.createObjectURL(compressedFile));
    } catch {
      toast.error("خطا در آپلود تصویر");
      setShowUploadIcon(true);
    }
  };

  const handleDateChange = (date) => {
    if (!date) {
      setDateValue(null);
      setStartDate("");
      return;
    }

    const gregorianDate = date.toDate();
    const formattedDate = gregorianDate.toISOString().slice(0, 10);

    setDateValue(date);
    setStartDate(formattedDate);
  };

  // مرتب‌سازی دانشجویان: اول تیک خورده‌ها، بعد بقیه به ترتیب الفبا
  const getSortedStudents = () => {
    const selected = students.filter(s => selectedStudents.includes(s.National_Code));
    const notSelected = students.filter(s => !selectedStudents.includes(s.National_Code));

    // مرتب‌سازی به ترتیب الفبای فارسی
    const sortByName = (a, b) => {
      const nameA = `${a.firstName} ${a.lastName}`;
      const nameB = `${b.firstName} ${b.lastName}`;
      return nameA.localeCompare(nameB, 'fa');
    };

    return [...selected.sort(sortByName), ...notSelected.sort(sortByName)];
  };

  const handleAddCourse = async () => {
    if (
        !courseName ||
        !teacherCode ||
        selectedStudents.length === 0 ||
        !startDate
    ) {
      toast.error("لطفاً همه فیلدهای ضروری را پر کنید");
      return;
    }

    try {
      await axios.post(
          `${API_BASE}/api/course/Add-Course`,
          {
            CourseName: courseName,
            CourseDescription: description,
            Teacher_National_Code: teacherCode,
            student_National_Codes: selectedStudents,
            Date_Classes: startDate,
            imageid: imageId || undefined,
            InitialPrice: Number(price) || 0,
            DisCount: hasDiscount ? Number(discount) : 0,
            FinalPrice: finalPrice,
          },
          { headers: { Authorization: localStorage.getItem("token") } }
      );

      toast.success("دوره با موفقیت ایجاد شد");
      navigate("/Mainpage/CoursesInf");
    } catch (err) {
      toast.error(err?.response?.data?.message || "خطا در ایجاد دوره");
    }
  };

  if (!localStorage.getItem("token")) return <Navigate to="/" />;

  return (
      <div className="relative min-h-screen w-full bg-gray-800 flex items-center justify-center p-4">
        <AnimatedBackground />

        <motion.div
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-5 m-9 w-full max-w-2xl mx-auto border border-white/30"
        >
          {/* هدر */}
          <div className="flex items-center justify-between mb-5">
            <img
                src={backarrow}
                alt="back"
                className="w-8 h-8 cursor-pointer hover:scale-110 transition"
                onClick={() => navigate(-1)}
            />
            <h2 className="text-xl font-bold text-gray-800">افزودن دوره جدید</h2>
            <div className="w-8" />
          </div>

          {/* آواتار */}
          <div className="flex justify-center my-5">
            <div
                onClick={() => document.getElementById("course-image").click()}
                className="relative w-24 h-24 rounded-full border-[3px] border-gray-700 overflow-hidden cursor-pointer shadow-lg hover:scale-105 transition"
            >
              <input
                  id="course-image"
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageUpload}
              />
              {showUploadIcon ? (
                  <div className="w-full h-full flex items-center justify-center bg-gray-100">
                    <MdOutlineFileUpload size={48} className="text-gray-600" />
                  </div>
              ) : (
                  <img
                      src={uploadImage}
                      alt="course"
                      className="w-full h-full object-cover"
                  />
              )}
            </div>
          </div>

          <div className="space-y-4 text-sm">
            <Input
                value={courseName}
                setValue={setCourseName}
                placeholder="نام دوره"
            />

            <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="توضیحات دوره..."
                rows={3}
                className="w-full p-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium resize-none bg-white/70"
            />

            {/* استاد */}
            <div ref={teacherRef} className="relative">
              <input
                  type="text"
                  value={teacherName}
                  onChange={(e) => {
                    setTeacherName(e.target.value);
                    searchTeachers(e.target.value);
                    setShowTeacherList(true);
                  }}
                  onFocus={() => teacherName && setShowTeacherList(true)}
                  placeholder="جستجوی استاد..."
                  className="w-full px-4 py-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium bg-white/70"
              />

              {/* نمایش استاد انتخاب شده */}
              {teacherCode && teacherName && (
                  <div className="mt-4 flex w-fit items-center gap-2 border-2 border-[#001d58]/30 rounded-lg px-3 py-2">
                <span className="text-sm text-[#001d58] font-medium">
                  استاد: {teacherName}
                </span>
                    <button
                        onClick={() => {
                          setTeacherName("");
                          setTeacherCode("");
                        }}
                        className="mr-auto text-red-500 hover:text-red-700 font-bold text-lg"
                    >
                      ✕
                    </button>
                  </div>
              )}

              {showTeacherList && (
                  <div className="absolute z-50 w-full mt-1 bg-white rounded-lg shadow-xl border border-gray-200 max-h-48 overflow-y-auto text-sm">
                    {teacherLoading ? (
                        <div className="p-4 text-center text-gray-500">
                          در حال جستجو...
                        </div>
                    ) : teachers.length === 0 ? (
                        <div className="p-4 text-center text-gray-500">
                          استادی یافت نشد
                        </div>
                    ) : (
                        teachers.map((t) => (
                            <div
                                key={t.National_Code}
                                onClick={() => {
                                  setTeacherName(`${t.firstName} ${t.lastName}`);
                                  setTeacherCode(t.National_Code);
                                  setShowTeacherList(false);
                                }}
                                className="px-4 py-2.5 hover:bg-[#001d58]/5 cursor-pointer transition border-b border-gray-100 last:border-b-0"
                            >
                              {t.firstName} {t.lastName}
                            </div>
                        ))
                    )}
                  </div>
              )}
            </div>

            {/* دانشجویان */}
            <div ref={studentRef} className="relative">
              <input
                  type="text"
                  value={studentName}
                  onChange={(e) => {
                    setStudentName(e.target.value);
                    searchStudents(e.target.value);
                    setShowStudentList(true);
                  }}
                  onFocus={() => studentName && setShowStudentList(true)}
                  placeholder="جستجو و انتخاب دانشجوها..."
                  className="w-full px-4 py-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium bg-white/70"
              />

              {/* نمایش دانشجویان انتخاب شده */}
              {selectedStudents.length > 0 && (
                  <div className="mt-1 flex flex-wrap gap-2 p-2 rounded-lg">
                    {selectedStudents.map((code) => (
                        <div
                            key={code}
                            className="flex items-center gap-2 border-2 border-[#001d58]/30 rounded-lg px-3 py-1.5"
                        >
                    <span className="text-sm text-[#001d58] font-medium">
                      {selectedStudentNames[code] || code}
                    </span>
                          <button
                              onClick={() => {
                                setSelectedStudents(prev => prev.filter(c => c !== code));
                                setSelectedStudentNames(prev => {
                                  const newNames = {...prev};
                                  delete newNames[code];
                                  return newNames;
                                });
                              }}
                              className="text-red-500 hover:text-red-700 font-bold"
                          >
                            ✕
                          </button>
                        </div>
                    ))}
                  </div>
              )}

              {showStudentList && (
                  <div className="absolute z-50 w-full mt-1 bg-white rounded-lg shadow-xl border border-gray-200 max-h-60 overflow-y-auto text-sm">
                    {studentLoading ? (
                        <div className="p-4 text-center text-gray-500">
                          در حال جستجو...
                        </div>
                    ) : students.length === 0 ? (
                        <div className="p-4 text-center text-gray-500">
                          دانشجویی یافت نشد
                        </div>
                    ) : (
                        getSortedStudents().map((s) => {
                          const isSelected = selectedStudents.includes(s.National_Code);
                          return (
                              <label
                                  key={s.National_Code}
                                  className={`flex items-center justify-between px-4 py-2.5 cursor-pointer transition border-b border-gray-200 last:border-b-0 ${
                                      isSelected ? 'bg-[#001d58]/5' : 'hover:bg-gray-50'
                                  }`}
                              >
                        <span className={isSelected ? 'font-medium text-[#001d58]' : ''}>
                          {s.firstName} {s.lastName}
                        </span>
                                <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => {
                                      const fullName = `${s.firstName} ${s.lastName}`;
                                      setSelectedStudents((prev) =>
                                          prev.includes(s.National_Code)
                                              ? prev.filter((c) => c !== s.National_Code)
                                              : [...prev, s.National_Code]
                                      );
                                      setSelectedStudentNames((prev) => {
                                        if (isSelected) {
                                          const newNames = {...prev};
                                          delete newNames[s.National_Code];
                                          return newNames;
                                        } else {
                                          return {...prev, [s.National_Code]: fullName};
                                        }
                                      });
                                    }}
                                    className="w-5 h-5 rounded border-gray-400 text-[#001d58] focus:ring-[#001d58]"
                                />
                              </label>
                          );
                        })
                    )}
                  </div>
              )}
            </div>

            {/* تاریخ + قیمت */}
            <div className="grid grid-cols-2 gap-3">
              <div className="relative">
                <DatePicker
                    value={dateValue}
                    onChange={handleDateChange}
                    calendar={persian}
                    locale={persian_fa}
                    format="YYYY/MM/DD"
                    placeholder="تاریخ شروع"
                    inputClass="w-full px-3 py-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 text-sm text-right bg-white/70"
                />
              </div>
              <Input
                  value={price}
                  setValue={setPrice}
                  placeholder="قیمت (تومان)"
                  onlyNumbers
              />
            </div>

            {/* تخفیف */}
            <div className="flex items-center gap-4">
              <span className="font-bold text-gray-800 text-sm">تخفیف؟</span>
              <button
                  type="button"
                  onClick={() => {
                    setHasDiscount(!hasDiscount);
                    !hasDiscount && setDiscount("");
                  }}
                  className={`relative w-12 h-7 rounded-full transition ${
                      hasDiscount ? "bg-gray-800" : "bg-gray-300"
                  }`}
              >
              <span
                  className={`absolute top-1 w-5 h-5 bg-white rounded-full shadow transition ${
                      hasDiscount ? "translate-x-5" : "translate-x-1"
                  }`}
              />
              </button>
              {hasDiscount && (
                  <div className="flex items-center gap-2">
                    <Input
                        value={discount}
                        setValue={setDiscount}
                        placeholder="درصد"
                        maxLength={3}
                        onlyNumbers
                        className="w-20"
                    />
                    <span>%</span>
                  </div>
              )}
            </div>

            {/* قیمت نهایی */}
            <div className="bg-gray-100 rounded-lg p-4 text-center">
              <p className="font-bold text-gray-800">
                قیمت نهایی: {finalPrice.toLocaleString()} تومان
              </p>
            </div>

            <motion.button
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleAddCourse}
                className="w-full py-4 bg-gray-800 hover:bg-gray-900 text-white font-bold rounded-lg shadow-xl transition mt-4"
            >
              ایجاد دوره
            </motion.button>
          </div>
        </motion.div>
      </div>
  );
};

const Input = ({
                 value,
                 setValue,
                 placeholder,
                 maxLength,
                 onlyNumbers,
                 className = "",
               }) => (
    <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        onKeyDown={(e) =>
            onlyNumbers &&
            !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(e.key) &&
            e.preventDefault()
        }
        className={`w-full px-4 py-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium text-sm bg-white/70 transition ${className}`}
    />
);

export default AddCourse;